// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"pageitem_pageBtn__VoNHd","xs":"pageitem_xs__16gmF"};